import Vue from 'vue'
import Vuex from 'vuex'
// default store
import state from './default/state'
import mutations from './default/mutations'
import actions from './default/actions'
import getters from './default/getters'
// add modules
import { services } from "./modules/services.js"
import { detailCodes } from './modules/detailCodes.js'
import { settings } from './modules/settings.js'
import { seniors } from './modules/seniors.js'
import { recipients } from './modules/recipients.js'
import { employees } from './modules/employees.js'
import { members } from './modules/members.js'
import { calendars } from './modules/calendars.js'
import { timelines } from './modules/timelines.js'
import { socials, blogs, commons, notices, states } from './modules/extra.js'
import { approvals } from './modules/approvals.js'
import { financials } from  './modules/financials.js'
import { maps } from './modules/maps.js'
import { link } from './modules/link.js'
// prevent initialize vuex store while refresh pages
// import createPersistedState from "vuex-persistedstate"
// import Cookies from 'js-cookie'
// import SecureLS from "secure-ls"
// const ls = new SecureLS({ isCompression: true })

Vue.use(Vuex)

// common vuex
const store = new Vuex.Store({
    state: state,
    // plugins: [
    //     createPersistedState({
    //         storage: window.sessionStorage, // if use this one, 
    //         storage: {
    //             getItem: key => ls.get(key),
    //             setItem: (key, value) => ls.set(key, value),
    //             removeItem: key => ls.remove(key)
    //         },
    //         // paths: ['senior', 'recipient', 'employee', 'member']
    //         paths: ['member'] // if remove this one, all store values are saved
    //     })
    // ],
    mutations: mutations,
    actions: actions,
    getters: getters,
    modules: {
        service: services,
        map: maps,
        detailCode: detailCodes,
        setting: settings,
        senior: seniors,
        recipient: recipients,
        employee: employees,
        sns: socials,
        blog: blogs,
        notice: notices,
        state: states,
        common: commons,
        member: members,
        calendar: calendars,
        timeline: timelines,
        approval: approvals,
        financial: financials,
        link: link,
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js